// Generated by scripts/build-mh-characters.mjs from scripts/mh/catalog.json: do not edit.
export const MH_KIT = {
  sliders: [
    {
      id: "height",
      group: "body",
    },
    {
      id: "weight",
      group: "body",
    },
    {
      id: "muscle",
      group: "body",
    },
    {
      id: "age",
      group: "body",
    },
    {
      id: "proportions",
      group: "body",
    },
    {
      id: "breast",
      group: "body",
    },
    {
      id: "shoulders",
      group: "body",
    },
    {
      id: "chest",
      group: "body",
    },
    {
      id: "waist",
      group: "body",
    },
    {
      id: "hips",
      group: "body",
    },
    {
      id: "belly",
      group: "body",
    },
    {
      id: "buttocks",
      group: "body",
    },
    {
      id: "neckLength",
      group: "body",
    },
    {
      id: "neckWidth",
      group: "body",
    },
    {
      id: "armLength",
      group: "body",
    },
    {
      id: "legLength",
      group: "body",
    },
    {
      id: "headSize",
      group: "face",
    },
    {
      id: "faceFullness",
      group: "face",
    },
    {
      id: "faceSquare",
      group: "face",
    },
    {
      id: "faceTaper",
      group: "face",
    },
    {
      id: "faceLength",
      group: "face",
    },
    {
      id: "jawWidth",
      group: "face",
    },
    {
      id: "chinWidth",
      group: "face",
    },
    {
      id: "chinHeight",
      group: "face",
    },
    {
      id: "chinProtrusion",
      group: "face",
    },
    {
      id: "cheekbones",
      group: "face",
    },
    {
      id: "cheekVolume",
      group: "face",
    },
    {
      id: "forehead",
      group: "face",
    },
    {
      id: "noseSize",
      group: "face",
    },
    {
      id: "noseWidth",
      group: "face",
    },
    {
      id: "noseLength",
      group: "face",
    },
    {
      id: "noseBridge",
      group: "face",
    },
    {
      id: "noseTip",
      group: "face",
    },
    {
      id: "nostrils",
      group: "face",
    },
    {
      id: "eyeSize",
      group: "face",
    },
    {
      id: "eyeSpacing",
      group: "face",
    },
    {
      id: "eyeTilt",
      group: "face",
    },
    {
      id: "eyeOpening",
      group: "face",
    },
    {
      id: "browHeight",
      group: "face",
    },
    {
      id: "browAngle",
      group: "face",
    },
    {
      id: "lipFullness",
      group: "face",
    },
    {
      id: "mouthWidth",
      group: "face",
    },
    {
      id: "mouthHeight",
      group: "face",
    },
    {
      id: "mouthCorners",
      group: "face",
    },
    {
      id: "earSize",
      group: "face",
    },
    {
      id: "earProtrusion",
      group: "face",
    },
  ],
  skins: [
    {
      id: "m-porcelain",
      sex: "male",
    },
    {
      id: "m-fair",
      sex: "male",
    },
    {
      id: "m-light",
      sex: "male",
    },
    {
      id: "m-olive",
      sex: "male",
    },
    {
      id: "m-tan",
      sex: "male",
    },
    {
      id: "m-brown",
      sex: "male",
    },
    {
      id: "m-dark",
      sex: "male",
    },
    {
      id: "m-deep",
      sex: "male",
    },
    {
      id: "f-porcelain",
      sex: "female",
    },
    {
      id: "f-fair",
      sex: "female",
    },
    {
      id: "f-light",
      sex: "female",
    },
    {
      id: "f-olive",
      sex: "female",
    },
    {
      id: "f-tan",
      sex: "female",
    },
    {
      id: "f-brown",
      sex: "female",
    },
    {
      id: "f-dark",
      sex: "female",
    },
    {
      id: "f-deep",
      sex: "female",
    },
  ],
  eyes: ["brown", "hazel", "green", "blue", "grey", "teal"],
  items: [
    {
      id: "eyes",
      slot: "eyes",
      sexes: ["male", "female"],
    },
    {
      id: "lashes-m",
      slot: "lashes",
      sexes: ["male"],
    },
    {
      id: "lashes-f",
      slot: "lashes",
      sexes: ["female"],
    },
    {
      id: "brows-natural",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "brows-arched",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "brows-soft",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "brows-thin",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "brows-bold",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "brows-straight",
      slot: "brows",
      sexes: ["male", "female"],
    },
    {
      id: "hair-short-crop",
      slot: "hair",
      sexes: ["male"],
    },
    {
      id: "hair-short-side",
      slot: "hair",
      sexes: ["male"],
    },
    {
      id: "hair-short-messy",
      slot: "hair",
      sexes: ["male"],
    },
    {
      id: "hair-pixie",
      slot: "hair",
      sexes: ["male", "female"],
    },
    {
      id: "hair-afro",
      slot: "hair",
      sexes: ["male", "female"],
    },
    {
      id: "hair-bob",
      slot: "hair",
      sexes: ["female"],
    },
    {
      id: "hair-bob-long",
      slot: "hair",
      sexes: ["female"],
    },
    {
      id: "hair-long",
      slot: "hair",
      sexes: ["female", "male"],
    },
    {
      id: "hair-ponytail",
      slot: "hair",
      sexes: ["female"],
    },
    {
      id: "hair-braid",
      slot: "hair",
      sexes: ["female"],
    },
    {
      id: "beard-stubble",
      slot: "beard",
      sexes: ["male"],
    },
    {
      id: "beard-moustache",
      slot: "beard",
      sexes: ["male"],
    },
    {
      id: "beard-full",
      slot: "beard",
      sexes: ["male"],
    },
    {
      id: "beard-long",
      slot: "beard",
      sexes: ["male"],
    },
    {
      id: "beard-goatee",
      slot: "beard",
      sexes: ["male"],
    },
    {
      id: "top-suit-tie",
      slot: "top",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "top-suit-3",
      slot: "top",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "top-suit-classic",
      slot: "top",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "top-suit-double",
      slot: "top",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "top-shirt-striped",
      slot: "top",
      style: "smart",
      sexes: ["male"],
    },
    {
      id: "top-jacket-casual",
      slot: "top",
      style: "smart",
      sexes: ["male"],
    },
    {
      id: "top-sweater",
      slot: "top",
      style: "smart",
      sexes: ["male", "female"],
    },
    {
      id: "top-tee",
      slot: "top",
      style: "casual",
      sexes: ["male", "female"],
    },
    {
      id: "top-polo",
      slot: "top",
      style: "sport",
      sexes: ["male"],
    },
    {
      id: "top-suit-f",
      slot: "top",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "top-suit-f2",
      slot: "top",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "top-suit-f-double",
      slot: "top",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "top-blouse",
      slot: "top",
      style: "smart",
      sexes: ["female"],
    },
    {
      id: "top-turtleneck",
      slot: "top",
      style: "smart",
      sexes: ["female"],
    },
    {
      id: "top-tee-f",
      slot: "top",
      style: "casual",
      sexes: ["female"],
    },
    {
      id: "top-sport-f",
      slot: "top",
      style: "sport",
      sexes: ["female"],
    },
    {
      id: "bottom-suit",
      slot: "bottom",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "bottom-suit-classic",
      slot: "bottom",
      style: "business",
      sexes: ["male"],
    },
    {
      id: "bottom-chinos",
      slot: "bottom",
      style: "smart",
      sexes: ["male", "female"],
    },
    {
      id: "bottom-jeans",
      slot: "bottom",
      style: "casual",
      sexes: ["male", "female"],
    },
    {
      id: "bottom-cargo",
      slot: "bottom",
      style: "casual",
      sexes: ["male", "female"],
    },
    {
      id: "bottom-shorts",
      slot: "bottom",
      style: "sport",
      sexes: ["male", "female"],
    },
    {
      id: "bottom-suit-f",
      slot: "bottom",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "bottom-suit-f2",
      slot: "bottom",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "bottom-skirt",
      slot: "bottom",
      style: "smart",
      sexes: ["female"],
    },
    {
      id: "bottom-jeans-f",
      slot: "bottom",
      style: "casual",
      sexes: ["female"],
    },
    {
      id: "bottom-leggings",
      slot: "bottom",
      style: "sport",
      sexes: ["female"],
    },
    {
      id: "shoes-oxford",
      slot: "shoes",
      style: "business",
      sexes: ["male", "female"],
    },
    {
      id: "shoes-loafer",
      slot: "shoes",
      style: "smart",
      sexes: ["male", "female"],
    },
    {
      id: "shoes-boots",
      slot: "shoes",
      style: "smart",
      sexes: ["male", "female"],
    },
    {
      id: "shoes-sneaker-white",
      slot: "shoes",
      style: "casual",
      sexes: ["male", "female"],
    },
    {
      id: "shoes-sneaker-blue",
      slot: "shoes",
      style: "sport",
      sexes: ["male", "female"],
    },
    {
      id: "shoes-flats",
      slot: "shoes",
      style: "smart",
      sexes: ["female"],
    },
    {
      id: "shoes-booties",
      slot: "shoes",
      style: "business",
      sexes: ["female"],
    },
    {
      id: "glasses-frames",
      slot: "accessory",
      sexes: ["male", "female"],
    },
    {
      id: "glasses-round",
      slot: "accessory",
      sexes: ["male", "female"],
    },
    {
      id: "glasses-square",
      slot: "accessory",
      sexes: ["male", "female"],
    },
    {
      id: "hat-fedora",
      slot: "accessory",
      sexes: ["male", "female"],
      hidesHair: true,
    },
    {
      id: "hat-newsboy",
      slot: "accessory",
      sexes: ["male", "female"],
      hidesHair: true,
    },
  ],
} as const;
